'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002edigitalinternship$002e$002dPage from "./io.intela.sites.digitalinternship.-Page.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_Page$Segment(key) {
  this.fs = null;
  this.fs = key;
}
export { $c_Lio_intela_sites_digitalinternship_Page$Segment as $c_Lio_intela_sites_digitalinternship_Page$Segment };
$p = $c_Lio_intela_sites_digitalinternship_Page$Segment.prototype = new $j_io$002eintela$002esites$002edigitalinternship$002e$002dPage.$h_Lio_intela_sites_digitalinternship_Page();
$p.constructor = $c_Lio_intela_sites_digitalinternship_Page$Segment;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_Page$Segment() {
}
export { $h_Lio_intela_sites_digitalinternship_Page$Segment as $h_Lio_intela_sites_digitalinternship_Page$Segment };
$h_Lio_intela_sites_digitalinternship_Page$Segment.prototype = $p;
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, (-1810946596), true);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_Page$Segment)) {
    var x = this.fs;
    var x$2 = x$0.fs;
    return (x === x$2);
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 1;
});
$p.I = (function() {
  return "Segment";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.fs;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_digitalinternship_Page$Segment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bo)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_Page$Segment as $isArrayOf_Lio_intela_sites_digitalinternship_Page$Segment };
var $d_Lio_intela_sites_digitalinternship_Page$Segment = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_Page$Segment, "io.intela.sites.digitalinternship.Page$Segment", ({
  bo: 1,
  av: 1,
  b: 1,
  e: 1,
  a: 1,
  C: 1
}));
export { $d_Lio_intela_sites_digitalinternship_Page$Segment as $d_Lio_intela_sites_digitalinternship_Page$Segment };
//# sourceMappingURL=io.intela.sites.digitalinternship.-Page$-Segment.js.map
